import { postToServer } from "../utils/postToServer";
import b64toBlob from "b64-to-blob";
import { uploadFileToS3 } from "../utils/uploadFileToS3";
import { getCDN } from "../utils/consts";
import { rootStore } from "../root";
import { getFontStyle, getFontWeight } from "../utils/fontFaceFileGenerator";
import { fixFileName } from "../utils/fixFileName";

export async function uploadFonts(self: any, filteredFonts: IFontsFromComp[]) {
  const fontsToUpload: IFontsToUpload[] = [];
  const fontsToEncodePromises = filteredFonts.map((font) =>
    postToServer("fonts", { font: font })
  );
  try {
    const encodedRes = await Promise.all(fontsToEncodePromises);
    encodedRes.forEach((res, i) => {
      const blob = b64toBlob(res.data);
      fontsToUpload.push({
        data: res.data,
        blob,
        name: filteredFonts[i].name,
        family: filteredFonts[i].family.replace(/'/g, ""),
        ext: filteredFonts[i].ext,
        isVariableFont: res.isVariableFont,
        hash: res.hash,
        weight: getFontWeight(
          filteredFonts[i].styleAndWeight,
          filteredFonts[i].name,
          filteredFonts[i].family,
          res.isVariableFont
        ),
        style: getFontStyle(
          filteredFonts[i].styleAndWeight,
          filteredFonts[i].name,
          filteredFonts[i].family,
          res.isVariableFont
        ),
      });
    });
  } catch (error) {
    console.log("error encoding fonts");
    const currentComposition =
      rootStore.compositionStore.compositionCurrentlyRendering;
    rootStore.uiStore.setProblemLayersData(
      { FontError: [`Fonts missing in ${currentComposition.name}`] },
      currentComposition.name
    );
    rootStore.compositionStore.setRenderedCompositions(
      currentComposition.id,
      false
    );
  }
  const fontFiles = fontsToUpload.map(
    ({
      blob,
      name,
      style,
      family,
      ext,
      isVariableFont,
      hash,
      weight,
      data,
    }) => {
      return {
        file: new File([blob], name),
        style,
        family,
        ext,
        name,
        isVariableFont,
        hash,
        data,
        weight,
      };
    }
  );
  const fontsUploadPromises = fontFiles.map(async (fontFile) =>
    uploadFileToS3(
      self.getFullUrlOfAsset(
        [`${fontFile.hash}_${fontFile.file.name}`, fontFile.ext].join("."),
        "fonts"
      ),
      {
        file: fontFile.file,
        stringData: fontFile.data,
      },
      `font/${fontFile.ext}`
    )
  );

  try {
    const fontsUploadRes = await Promise.all(fontsUploadPromises);
    const uploaded = fontsUploadRes.map((res, i) => {
      const { family, style, file, name, isVariableFont, weight } =
        fontFiles[i];

      return {
        url: `${getCDN()}/${res.key as string}`,
        family,
        style,
        name,
        file,
        isVariableFont,
        weight,
      };
    });
    const updatedJson = {
      ...self.compJson,
      // meta_b: { fffUrl: [`${getENV()}/${res.key}`] }, //Depreciated
      meta_b: { fffDef: uploaded },
    };
    self.setCompJson(updatedJson);
    self.setUploadedFonts(uploaded);
  } catch (error) {
    console.log("failed to upload fonts");
  }
}
